import { OFFER, B2B_MARGIN, b2bSales, internalBenefit, appBenefit, partnerFixed, brandCost, paybackMonth } from "./model";

export const RECOMMENDED = 2300;
const BRAND_TOTAL = 15400;
const ONLINE_REVENUE = 3150;
const ONLINE_MARGIN = 0.45;

const visibility = (x) => 1 / (1 + Math.exp(-(x - 1100) / 250));

// Efficacia della pubblicità rispetto al piano consigliato (1 = consigliato)
export const effect = (M) => (M <= 0 ? 0 : (visibility(M) * Math.pow(M / RECOMMENDED, 0.7)) / visibility(RECOMMENDED));

const ZONES = {
  none: { key: "ko", label: "Nessuna pubblicità", text: "Senza pubblicità restano i risparmi del gestionale, ma la linea per le aziende, le spedizioni e l'App crescono pochissimo: nessuno sa che esistono." },
  ko: { key: "ko", label: "Zona KO", text: "Gli annunci sono troppo deboli. Bella Napoli finisce dietro i concorrenti e quasi nessuno la vede: i soldi spesi non tornano indietro." },
  rischio: { key: "rischio", label: "Zona a rischio", text: "Si compare solo ogni tanto e dopo i concorrenti. Qualche risultato arriva, ma la pubblicità impiega più di un anno a ripagarsi." },
  ok: { key: "ok", label: "Zona consigliata", text: "Bella Napoli compare tra i primi risultati nei momenti che contano. Ogni euro investito torna indietro con un guadagno." },
  veloce: { key: "veloce", label: "Crescita veloce", text: "Si vende di più, ma ogni euro in più rende un po' meno del precedente. Ha senso solo se il laboratorio regge i volumi." },
};

export const zone = (M, pay) => {
  if (M <= 0) return ZONES.none;
  if (!pay) return ZONES.ko;
  if (pay > 14) return ZONES.rischio;
  return M <= 3000 ? ZONES.ok : ZONES.veloce;
};

// Margine generato dalla pubblicità nel mese m (B2B + App + vendite online dal 7° mese)
const adBenefit = (m, k, o) => {
  const online = m >= 7 ? ONLINE_REVENUE * ONLINE_MARGIN : 0;
  return (B2B_MARGIN - o.comm) * b2bSales(m, 60000 * k, 90000 * k) + (appBenefit(m) + online) * k;
};

const cumulate = (fn) => {
  let sum = 0;
  return Array.from({ length: 24 }, (_, i) => Math.round((sum += fn(i + 1))));
};

export function simulate(M, opt) {
  const o = OFFER[opt];
  const k = effect(M);
  const adsSeries = cumulate((m) => adBenefit(m, k, o) - M);
  const totalSeries = cumulate((m) => adBenefit(m, k, o) + internalBenefit(m) - M - partnerFixed(m, o) - brandCost(m));
  const salesY1 = 60000 * k;
  return {
    k,
    salesY1,
    adsSeries,
    totalSeries,
    adsPayback: M > 0 ? paybackMonth(adsSeries) : null,
    totalPayback: paybackMonth(totalSeries),
    spendY1: o.setup + o.fee * 10 + o.comm * salesY1 + M * 12 + BRAND_TOTAL,
    total24: totalSeries[23],
  };
}
